import React from 'react'
import ContentsList from '../../Components/Contents/ContentsList'
import queryString from 'query-string'

const PremiumContentsListPage = ({ match, location }) => {
  const query = queryString.parse(location.search)
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <ContentsList
        pageNumber={query.pageNumber}
        search={query.search}
        type={query.type}
        order={query.order}
        language={query.language}
        q={'premium'}
      />
    </React.Fragment>
  )
}

export default PremiumContentsListPage
